module.exports = __webpack_public_path__ + "img/climate_actions_nature@2x.113516a.jpg";